import { FaHome, FaUserAlt, FaClipboardList } from 'react-icons/fa';
import { BsFillCalendarEventFill, BsGearFill, BsFillCalendar2WeekFill } from 'react-icons/bs';
import { RiShieldUserFill } from 'react-icons/ri';

const SidebarData = [
  {
    id: 1,
    name: 'sidebar.dashboard',
    icon: <FaHome fontSize={26} />,
    url: '/admin',
    exact: true,
    view_permission: 'true'
  },
  {
    id: 2,
    name: 'sidebar.events',
    icon: <BsFillCalendarEventFill fontSize={26} />,
    url: '/admin/events',
    view_permission: 'true'
  },
  {
    id: 7,
    name: 'sidebar.event_calendar',
    icon: <BsFillCalendar2WeekFill fontSize={26} />,
    url: '/admin/calendar',
    view_permission: 'true'
  },
  {
    id: 3,
    name: 'sidebar.rosters',
    icon: <RiShieldUserFill fontSize={26} />,
    url: '/admin/rosters/individual_list',
    canViewRoles: ['superuser', 'cd_admin', 'executive']
    // view_permission: 'Can view resource person profile'
  },
  {
    id: 4,
    name: 'sidebar.users',
    icon: <FaUserAlt fontSize={26} />,
    url: '/admin/users',
    // view_permission: 'Can view user'
    canViewRoles: ['superuser', 'cd_admin', 'executive']
  },
  {
    id: 5,
    name: 'sidebar.settings',
    icon: <BsGearFill fontSize={26} />,
    url: '/admin/settings',
    view_permission: 'true'
  },
  {
    id: 6,
    name: 'sidebar.report',
    icon: <FaClipboardList fontSize={26} />,
    url: '/admin/report/overall',
    canViewRoles: ['superuser', 'cd_admin', 'executive']
  }
];
export default SidebarData;
